import { H2 } from '@vp/swan';
import { __ } from '@99designs/i18n';

export function RecommendationsHeader() {
    return (
        <H2>
            {__('Recommended for you', {
                _context:
                    'Header for the section displaying recommended design services for a customer',
            })}
        </H2>
    );
}
